import React from 'react'
import { Image } from '@chakra-ui/react'

interface IWebBeacon {
  src: string
  id: string
}

const WebBeacon: React.FC<IWebBeacon> = ({ src, id }) => (
    <Image
      data-testid='web-beacon'
      id={id}
      src={src}
      position='absolute'
      referrerPolicy='no-referrer-when-downgrade'
    />
  )

export default WebBeacon
